import { render, staticRenderFns } from "./ModelUpgradeConfig.vue?vue&type=template&id=5484f9c5&scoped=true&"
import script from "./ModelUpgradeConfig.vue?vue&type=script&lang=js&"
export * from "./ModelUpgradeConfig.vue?vue&type=script&lang=js&"
import style0 from "./ModelUpgradeConfig.vue?vue&type=style&index=0&id=5484f9c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5484f9c5",
  null
  
)

export default component.exports